// extracted by mini-css-extract-plugin
export default {"documents":"DocumentsAndContacts_documents__6ZuNm","list":"DocumentsAndContacts_list__zujuU"};